module.exports = __webpack_public_path__ + "static/media/intro_2.4c61833f.svg";